import moment from "moment";

// PO1-3214: o card "Ocorrências abertas" (IndicadoresEntrega) e o gráfico
// "Ocorrências em aberto" usam o MESMO recorte, senão os números não batem:
// o período global (botão Período) quando houver, senão os últimos 90 dias, e a
// transportadora selecionada.
export const DIAS_PADRAO_OCORRENCIAS = 90;

export function paramsOcorrenciasAbertas({ startDate, endDate, transportadoras }) {
  const inicio = startDate
    ? moment(startDate)
    : moment().subtract(DIAS_PADRAO_OCORRENCIAS, "days");
  const fim = endDate ? moment(endDate) : moment();
  const params = {
    dataInicial: inicio.format("YYYY-MM-DD 00:00:00"),
    dataFinal: fim.format("YYYY-MM-DD 23:59:59"),
  };
  if (transportadoras) params.transportadoras = transportadoras;
  return params;
}
